import { render, staticRenderFns } from "./ordonnance-medicale.html?vue&type=template&id=7140456a&scoped=true&external"
import script from "./ordonnance-medicale.js?vue&type=script&lang=js&external"
export * from "./ordonnance-medicale.js?vue&type=script&lang=js&external"
import style0 from "./ordonnance-medicale.scss?vue&type=style&index=0&id=7140456a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140456a",
  null
  
)

export default component.exports